// removed by extract-text-webpack-plugin
module.exports = {"brandPrimary":"#00A58C","brandPrimaryDarker":"#03816E","brandPrimaryDarkest":"#037060","headlineColor":"#fff","headlinePrimary":"#00A58C"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/export.css
// module id = 82
// module chunks = 0